<button
  [type]="type"
  [attr.form]="form"
  mat-flat-button
  [disabled]="disabled"
  [class]="classes"
>
  <div>
    {{ label }}
    @if (loading) {
    <mat-spinner class="mm-text-white" diameter="20"></mat-spinner>
    }
  </div>
</button>
